module.exports = __webpack_public_path__ + "static/team19-bdca99ed1a49e10ee601fa7c368bd2ff.jpg";